import * as React from 'react';
import * as revs from "./style.module.scss";
import data from "./data.json";
export const Revs = () => {
  const swiperEl = React.useRef();
  React.useEffect(() => {
    if (swiperEl.current) {
      Object.assign(swiperEl.current, {
        slidesPerView: 1,
        autoHeight: true,
        grabCursor: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
      swiperEl.current.initialize();
    }
  }, []);
  return (
    <section className={revs.revs}>
      <div className="container" style={{ position: "unset" }}>
        <h2>Отзывы</h2>
        <swiper-wrapper style={{ position: "relative" }}>
          <swiper-container
            ref={swiperEl}
            init="false"
            style={{
              width: "100%",
              overflowX: "hidden"
            }}
          >
            {data.map((elem, index) => (
              <swiper-slide key={index}>
                <img src={elem.avatar} alt={elem.author}/>
                <p>{elem.text}</p>
                <h3>{elem.author}</h3>
              </swiper-slide>
            ))}
          </swiper-container>
          <div>
            <button className={`swiper-button-prev ${revs.btnPrev}`} aria-label="swiper-button-prev"></button>
            <button className={`swiper-button-next ${revs.btnNext}`} aria-label="swiper-button-next"></button>
          </div>
          <div
            className="swiper-pagination"
            style={{
              "--swiper-pagination-bullet-size": "9px",
              "--swiper-pagination-color": '#be2623',
              position: "unset",
              marginTop: "35px"
            }}
          />
        </swiper-wrapper>
      </div>
    </section>
  );
};
